module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_74.0cc2edfb.jpg";